import { headerAuthorization } from '../../../shared/helpers/localstorage-helper';
import { Role } from '../../../shared/types/role';
import { SelectOption } from '../../../shared/types/select-options';
import { BASE_URL } from '../../../shared/consts/variables';

export const getRoles = async (): Promise<SelectOption[]> => {
    const response = await fetch(`${BASE_URL}/roles`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar roles');
    }

    const roles: Role[] = await response.json();
    

    const rolesSelectOption = roles.map((role: Role) => ({
        id: role.id,
        value: role.id,
        label: role.name,
    }));

    return rolesSelectOption;
};

export const getNonSuperAdminRoles = async (): Promise<SelectOption[]> => {
    const response = await fetch(`${BASE_URL}/roles?excludeSuperAdmin=true`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar roles');
    }

    const roles: Role[] = await response.json();

    const rolesSelectOption = roles.map((role: Role) => ({
        id: role.id,
        value: role.id,
        label: role.name,
    }));

    return rolesSelectOption;
};